import { render } from "./SchedaVisualizzazioneUtente.vue?vue&type=template&id=e8e0f386"
import script from "./SchedaVisualizzazioneUtente.vue?vue&type=script&lang=js"
export * from "./SchedaVisualizzazioneUtente.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__